import { render, staticRenderFns } from "./LogoSmall.vue?vue&type=template&id=97d387c8&"
import script from "./LogoSmall.vue?vue&type=script&lang=js&"
export * from "./LogoSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97d387c8')) {
      api.createRecord('97d387c8', component.options)
    } else {
      api.reload('97d387c8', component.options)
    }
    module.hot.accept("./LogoSmall.vue?vue&type=template&id=97d387c8&", function () {
      api.rerender('97d387c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LogoSmall.vue"
export default component.exports